<div class="main-container">
  <div class="inside-main-container" [ngSwitch]="machineSessioned.maC_ModelloSx">
    <app-parameter-non-linear *ngSwitchCase="3"></app-parameter-non-linear>
    <app-parameter-non-linear *ngSwitchCase="4"></app-parameter-non-linear>
    <app-parameter-non-linear *ngSwitchCase="5"></app-parameter-non-linear>
    <app-parameter-non-linear *ngSwitchCase="13"></app-parameter-non-linear>
    <app-parameter-non-linear *ngSwitchCase="15"></app-parameter-non-linear>
    <app-parameter-non-linear *ngSwitchCase="16"></app-parameter-non-linear>
    <app-parameter-linear *ngSwitchDefault></app-parameter-linear>
  </div>
</div>
